module.exports = __webpack_public_path__ + "static/media/eaton-boomers.0743e032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/eaton-boomers.jpg
// module id = 186
// module chunks = 0